/**
 * Checks if conditions are met based on blockState values
 * @param {Array} conditions - Array of condition objects
 * @param {Object} blockState - The state object containing field values
 * @returns {boolean} - Returns true if conditions are met, false otherwise
 */
export const checkConditions = (conditions, blockState) => {
    if (!conditions || conditions.length === 0) return true;

    let result = null;

    for (const cond of conditions) {
        const fieldValue = blockState[cond.selectedConditionDataElement];
        if (fieldValue === undefined || fieldValue === null) continue;

        let isMet = false;
        switch (cond.selectedConditionOperator) {
            case 'is_equals':
                isMet = fieldValue === cond.value;
                break;
            case 'is_not_equals':
                isMet = fieldValue !== cond.value;
                break;
            case 'contains':
                isMet = Array.isArray(fieldValue) && fieldValue.includes(cond.value);
                break;
            case 'not_contains':
                isMet = Array.isArray(fieldValue) && !fieldValue.includes(cond.value);
                break;
            default:
                isMet = true;
        }

        if (cond.selectedConditionClause === 'or') {
            result = result === null ? isMet : result || isMet;
        } else if (cond.selectedConditionClause === 'and') {
            result = result === null ? isMet : result && isMet;
        }
    }
    return result === null ? false : result;
};


export const generateId = (sentence) => {
    const prefix = sentence
        .split(" ")
        .map(word => word.charAt(0).toUpperCase())
        .join("");
    const randomNum = Math.floor(100000000 + Math.random() * 900000000);
    return `#${prefix}${randomNum}`;
};

export const clearCurrentChartReduxStore = (props, subKeys) => {
    props.clearReduxDataOfCurrentComponent({
        key: 'document',
        subKey: subKeys
    })
}

export const chatRedirect = (history, appid, listPages) => {
    history?.push({
        pathname: `/${appid}/page/${listPages}`
    });
}